import React, {useState, useEffect, useLayoutEffect, useRef} from 'react';
import './App.css';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import axios from 'axios';
import {keepPreviousData, useQuery} from '@tanstack/react-query';

const Panneltwo =()=>{
const [dasi, setdasi] = useState(false);
const [mona, setmona] = useState(true);
const [iq, setiq] = useState(0);
const [nodouble, setnodouble] = useState(false);
const [noups, setnoups]= useState(false);
const moveon = useRef();
const juka = useRef(null);
const moke = useRef(null);

const sono = () => {
    if (!moveon.current) return;
    clearTimeout(juka.current);
    clearTimeout(moke.current);

    const mabos = last?.z?.length % 2 == 0 ? 16.666 : 0;
    moveon.current.style.transform = `translateX(-${mabos}%)`;
    void moveon.current.offsetWidth;

    requestAnimationFrame(() => {
        moveon.current.style.transition = 'transform 0.5s ease-out';
        moveon.current.style.transform = `translateX(-${33.333 + mabos}%)`;
    });

    if(iq == last?.z?.length-1){
        document.getElementById(`b${iq}`).classList.replace('actio','nonactio');
        setiq(0);
        document.getElementById('b0').classList.replace('nonactio','actio');
    }else{
    document.getElementById(`b${iq}`).classList.replace('actio','nonactio');

    document.getElementById(`b${iq+1}`).classList.replace('nonactio','actio');
    setiq(iq+1);
    };
    juka.current = setTimeout(() => {
        if(moveon.current == null){return;};
        moveon.current.appendChild(moveon.current.firstElementChild);
        moveon.current.style.transition = 'none';
        moveon.current.style.transform = `translate(-${mabos}%)`;
        moke.current = setTimeout(() => {
            moveon.current.style.transition = 'all 0.5s';
            setmona(!mona);
        }, 20);
    }, 800);
};

const kuara = () => {
    setdasi(true);
};

const kirara = () => {
    setdasi(false);
};

const mahina = ()=>{
    setdasi(true);
};
const amena =()=>{
    setdasi(false);
};

const noflow = () =>{
    if(nodouble){
        return nodouble;
    }else{
        setnodouble(true);
        return false;
    }
};

const supo = () => {
    if(noflow()) return;
    setdasi(true);
    const mabos = last?.z?.length % 2 == 0 ? 16.666 : 0;
    moveon.current.style.transform = `translate(-${mabos}%)`;
    void moveon.current.offsetWidth;
    const kimz = last?.z?.length - 1;

    requestAnimationFrame(() => {
        moveon.current.style.transition = 'transform 0.5s ease-out';
        moveon.current.style.transform = `translateX(-${33.333 + mabos}%)`;
    });

    if(iq == 0){
        document.getElementById(`b${iq}`).classList.replace('actio','nonactio');
        document.getElementById(`b${last?.z?.length-1}`).classList.replace('nonactio','actio');
        setiq(kimz);
    }else{
    document.getElementById(`b${iq}`).classList.replace('actio','nonactio');
    document.getElementById(`b${iq-1}`).classList.replace('nonactio','actio');
    setiq(iq-1);
    };
    const juki = setTimeout(() => {
        moveon.current.appendChild(moveon.current.firstElementChild);
        moveon.current.style.transition = 'none';
        moveon.current.style.transform = `translate(-${mabos}%)`;
        const moa = setTimeout(() => {
            moveon.current.style.transition = 'all 0.5s';
            setnodouble(false);
            clearTimeout(moa);
        }, 20);  
       clearTimeout(juki);
    }, 800);
};

const upflow = () =>{
    if(noups){
        return noups;
    }else{
        setnoups(true);
        return false;
    }
};

const sdwo = () => {
    if(upflow()) return;
    setdasi(true);
    const mabos = last?.z?.length % 2 == 0 ? 16.666 : 0;
    moveon.current.style.transform = `translateX(-${mabos}%)`;
    void moveon.current.offsetWidth;

    requestAnimationFrame(() => {
        moveon.current.style.transition = 'transform 0.5s ease-out';
        moveon.current.style.transform = `translateX(${33.333 - mabos}%)`;
        });

    if(iq == last?.z?.length-1){ 
        document.getElementById(`b${iq}`).classList.replace('actio','nonactio');
        document.getElementById('b0').classList.replace('nonactio','actio');
        setiq(0);    
    }else{
    document.getElementById(`b${iq}`).classList.replace('actio','nonactio');
    document.getElementById(`b${iq+1}`).classList.replace('nonactio','actio');
    setiq(iq+1);
    };
    const juki = setTimeout(() => {
        moveon.current.prepend(moveon.current.lastElementChild);
        moveon.current.style.transition = 'none';
        moveon.current.style.transform = `translate(-${mabos}%)`;
        const moa = setTimeout(() => {
            moveon.current.style.transition = 'all 0.5s';
            setnoups(false);
            clearTimeout(moa);
        }, 20);
        clearTimeout(juki);
    }, 800);
};

const fnax = async (signal) => {
    const { data : hooko } = await axios.get('/api/carousel', { signal });
    const data = {h : vggle(hooko.main), z : zggle(hooko.subm), a : uggle(hooko.sub1), b: uggle(hooko.sub2), c: uggle(hooko.sub3), d: aggle(hooko.sub3, hooko.event), e:uggle(hooko.event)};
    return data;
};

const {isPending, data : last} = useQuery({queryKey:['ka'], queryFn: ({signal})=>fnax(signal), 
placeholderData: keepPreviousData, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 30 });

useEffect(() => {
    if (dasi == true) return;
    if (!last?.z?.length) return;
    if(last?.z?.length <= 3) return;
   const kci = setTimeout(() => { sono(); }, 4800);
    return () => { clearTimeout(kci);};
},
    [mona, dasi, last]);

const uggle =(arar)=>{
    if(arar.length === 0 || arar === undefined) return arar;
    for (let i = arar.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [arar[i], arar[j]] = [arar[j], arar[i]];
      };
     return arar;
};

const vggle =(arar)=>{
    if(arar.length === 0) return [{link : "#", image : "dolpa_m.png", period : "", title : "돌파공모"}];
   
    for (let i = arar.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [arar[i], arar[j]] = [arar[j], arar[i]];
      };

    if (arar.length === 2) {
        return [...arar, {link : "#", image : "dolpa_m.png", period : "", title : "돌파공모"}];
    };

    return arar;
};

const zggle =(arar)=>{
    if(arar.length === 0) return [{link : "#", image : "dolpa_s.png", period : "", title : "돌파공모"}];
   
    for (let i = arar.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [arar[i], arar[j]] = [arar[j], arar[i]];
      };

    if (arar.length === 2) {
        return [...arar, {link : "#", image : "dolpa_s.png", period : "", title : "돌파공모"}];
    }else if(arar.length === 4) {
        return [...arar, {link : "#", image : "dolpa_s.png", period : "", title : "돌파공모"}];
    };

    return arar;
};
  

const aggle =(a, b)=>{
    const ugoka = a.concat(b);
    for (let i = ugoka.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [ugoka[i], ugoka[j]] = [ugoka[j], ugoka[i]];
      };
     return ugoka;
};

const onmark=(e)=>{
    setdasi(true);
    const soo = parseInt(e.target.id.substring(1));
    const siq = iq-soo;
     const mabos = last?.z?.length % 2 == 0 ? 16.666 : 0;
    
    if(siq>0){
        for(let i=0; i<siq; i++){
            moveon.current.prepend(moveon.current.lastElementChild);
        };
       
        // moveon.current.style.transform = `translate(${33.333 * siq - mabos}%)`
      //  moveon.current.style.transition = 'all 0.5s';
        document.getElementById(`b${iq}`).classList.replace('actio','nonactio');
        document.getElementById(`b${soo}`).classList.replace('nonactio','actio');
        setiq(soo);
    }else if(siq<0){
        for(let i=siq; i<0; i++){
            moveon.current.appendChild(moveon.current.firstElementChild);
        };
   
    // moveon.current.style.transform = `translate(-${mabos}%)`;
        // moveon.current.style.transition = 'all 0.5s';
        document.getElementById(`b${iq}`).classList.replace('actio','nonactio');
        document.getElementById(`b${soo}`).classList.replace('nonactio','actio');
        setiq(soo);
    }else{
        setiq(soo);
    }
};
   
return(
<div className='gggn'>
<div className='moewa2'>
    <div className='slid2' ref={moveon} onMouseOver={kuara} onMouseOut={kirara} style={{ '--kanoo': (last?.z?.length || 0) % 2 === 1 ? 0 : 1, '--panoo': (last?.z?.length || 0) == 1 ? 1 : 0 }}>
    {last?.z?.length >0 && last.z.map((con, i)=>{ return (<div className='iware2'>
        <Link to={`../ajo/${con.link}`} className='iwang' onClick={()=>{ 
                window.history.states = {nopi : window.scrollY}; 
                window.history.tates = {nopi : window.scrollY};}}>
            <img src={process.env.PUBLIC_URL+`/document/${con.image}`} />
            <div className='fly'>
                <p className='bokuni'>{dayjs(con.online).format('YYYY.M.D')}~{dayjs(con.offline).format('YYYY.M.D')}</p>
                <p className='bokuni'>{con.title}</p>
            </div>
            </Link>
        </div>)})}
    </div>
    {last?.z?.length > 3 &&
    <div className='contro'>
        <span className='ape' style={{top : "118px"}} onClick={supo} onMouseOver={mahina} onMouseOut={amena}><img src={process.env.PUBLIC_URL+'/sidel.png'}/></span>
        <span className='due' style={{top : "118px"}} onClick={sdwo} onMouseOver={mahina} onMouseOut={amena}><img src={process.env.PUBLIC_URL+'/sider.png'}/></span>
    </div>}
</div>
<ul className='jiji'>
    {last?.z?.length >0 && last.z.map((con, i)=>{if(i == 0){return (<li>         
            <button className='actio' id="b0" onClick={onmark} onMouseOut={amena}></button>
        </li>)}else{ return (<li>         
            <button id={`b${i}`} onClick={onmark} onMouseOut={amena} className='nonactio'></button>
        </li>)}})}  
</ul>
</div>
)
};

export default Panneltwo;